import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { getAff } from "@/lib/affiliate";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    (async () => {
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const pendingLead = localStorage.getItem("pending_lead") || undefined;
        const pendingRef = localStorage.getItem("pending_ref") || undefined;
        const pendingIntent = localStorage.getItem("pending_intent") || undefined;
        const pendingPlan = localStorage.getItem("pending_plan") || undefined;
        const { data } = await api.post("/auth/google/session", { session_id: sessionId, language: navigator.language, lead_id: pendingLead, ref: pendingRef, aff: getAff() || undefined });
        localStorage.removeItem("pending_lead");
        localStorage.removeItem("pending_ref");
        localStorage.removeItem("pending_intent");
        localStorage.removeItem("pending_plan");
        loginWithToken(data.token, data.user);
        let dest = pendingLead ? "/welcome" : "/profile";
        if (pendingIntent === "purchase") dest = pendingPlan ? `/billing?plan=${pendingPlan}` : "/billing";
        if (pendingLead) localStorage.setItem("welcome_lead", pendingLead);
        window.history.replaceState(null, "", dest);
        navigate(dest, { replace: true });
      } catch (e) {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, loginWithToken]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
        <p className="text-sm text-muted-foreground">Signing you in…</p>
      </div>
    </div>
  );
}
